module.exports = __webpack_public_path__ + "static/media/toastIcon.be349600.svg";